module.exports = __webpack_public_path__ + "img/1F1EF-1F1EA.d45bb2f1.svg";